import { useQuery } from "@tanstack/react-query";

import { authApi } from "@/features/identity/services/auth.api";
import { getAccessToken } from "@/lib/token-storage";

/**
 * `enabled: Boolean(getAccessToken())` — a fresh guest visitor has no token
 * to check, so this never fires a doomed 401 round-trip for them.
 * `retry: false` because a failure here means "not actually logged in,"
 * not "transient network blip worth retrying" — src/lib/interceptors.ts's
 * 401 handling already takes care of clearing a genuinely invalid token.
 */
export function useCurrentUser() {
  return useQuery({
    queryKey: ["auth", "me"],
    queryFn: authApi.getCurrentUser,
    enabled: Boolean(getAccessToken()),
    retry: false,
  });
}
